export default __webpack_public_path__ + "static/media/AboutIcon.6a6ee129.svg";